/** Noten (Roadmap F-22, Stufe 4). */
import { db } from '@/db/schema';
import { inDenPapierkorb } from '@/db/repositories/papierkorb';
import { gueltigerWert } from '@/domain/school/grades';
import { formatDate, nowInstant } from '@/lib/datetime';
import { newId } from '@/lib/utils/id';
import type { Grade, ID, LocalDate, Notensystem } from '@/domain/types';

export interface NeueNote {
  subjectId: ID;
  date: LocalDate;
  value: number;
  system: Notensystem;
  weight: number;
  art: string;
  note?: string;
}

/** Legt eine Note an - ungueltige Werte oder Gewichte werden abgelehnt. */
export async function addGrade(n: NeueNote): Promise<Grade | null> {
  if (!gueltigerWert(n.value, n.system) || !(n.weight > 0) || !n.date) return null;
  if (!(await db.subjects.get(n.subjectId))) return null;
  const ts = nowInstant();
  const grade: Grade = {
    id: newId(),
    subjectId: n.subjectId,
    date: n.date,
    value: n.value,
    system: n.system,
    weight: n.weight,
    art: n.art.trim() || 'Sonstiges',
    ...(n.note?.trim() ? { note: n.note.trim() } : {}),
    createdAt: ts,
    updatedAt: ts,
  };
  await db.grades.add(grade);
  return grade;
}

export async function deleteGrade(id: ID): Promise<void> {
  const n = await db.grades.get(id);
  const titel = n ? `${n.art} vom ${formatDate(n.date)}` : undefined;
  await inDenPapierkorb({ art: 'geloescht', tabelle: 'grades', zeileIds: [id], titel }, () => db.grades.delete(id));
}
